interface Options {
    class: string;
    delay: number;
}

ko.bindingHandlers.animate = {
    init: function (elem: HTMLElement, valueAccessor) {
        elem.style.display = 'none';
        const options: Options = ko.utils.unwrapObservable(valueAccessor());

        setTimeout(() => {
            elem.style.display = 'block';
            elem.classList.add(options.class);

        }, options.delay);
    }
}
ko.virtualElements.allowedBindings.animate = true;
